import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckoutShippingMethodsComponentDef } from '@df/checkout/checkout-shipping-methods.component.def';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { App } from '@df/core/app';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import compact from 'lodash-es/compact';
import isFunction from 'lodash-es/isFunction';
import minBy from 'lodash-es/minBy';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { Radio2Component } from '../../ui/form/radio2/radio2.component';
import { CheckoutFormComponent } from './../form/checkout-form.component';
import { CheckoutStepComponent } from './../step/checkout-step.component';
@Component({
    selector: 'checkout-shipping-methods',
    templateUrl: './checkout-shipping-methods.html',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        PriceComponent,
        InputWrapComponent,
        InputWrapBodyDirective,
        TranslationModule,
        ICmsClientModule,
        Radio2Component,
        RadioGroupDirective
    ]
})
export class CheckoutShippingMethodsComponent extends CheckoutShippingMethodsComponentDef implements OnInit {
    constructor(
        protected override checkoutFormComponent: CheckoutFormComponent,
        checkoutStepComponent: CheckoutStepComponent,
        app: App,
        changeDetectorRef: ChangeDetectorRef
    ) {
        super(checkoutFormComponent, checkoutStepComponent, app, changeDetectorRef);
    }
    get shouldHide(): boolean {
        if (this.noShippingNeeded) {
            return false;
        }
        const methods = this.methods;
        if (methods?.length === 1 && ['tcoshippingmethodflat2_tcoshippingmethodflat2'].indexOf(methods[0].code) !== -1) {
            return true;
        }
        return false;
    }
    get isSamples(): boolean {
        return this.checkoutFormComponent.isSamples;
    }

    get basketTotalPrice(): number {
        return this.checkoutFormComponent.app.customer.basket.totals.subtotal;
    }

    protected override pickFirst() {
        if (this.data) {
            let methods: Checkout.IShippingMethod[] | undefined;
            if (!this.data.method) {
                // autoPickShippingMethodIfOnlyOneAvailable
                if (
                    !methods &&
                    (this.moduleConfig.autoPickShippingMethodIfOnlyOneAvailable || this.isSamples) &&
                    this.methods.length === 1
                ) {
                    this.setMethod2(this.methods[0].code);
                } else {
                    // autoPickShippingMethod
                    const autoPick = this.moduleConfig.autoPickShippingMethod || this.isSamples;
                    if (autoPick) {
                        if (isFunction(autoPick)) {
                            methods = autoPick(this);
                        } else if (autoPick === true) {
                            methods = this.methods;
                        } else if (Array.isArray(autoPick)) {
                            methods = this.methods.filter(method => autoPick.includes(method.code));
                        }
                    }

                    // autoPickCheepestShippingMethod
                    if (this.moduleConfig.autoPickCheepestShippingMethod) {
                        if (!methods) {
                            methods = this.methods;
                        }
                        methods = compact([minBy(methods, i => i.price)]);
                    }

                    if (methods && methods.length) {
                        this.setMethod2(methods[0]?.code);
                    }
                    // make sure that method is undefined (otherwise our watch wont work as it skips change from undefiend to some value)
                    if (!this.data.method) {
                        this.setMethod2(undefined);
                    }
                }
            }
        }
    }

    private setMethod2(method: string | undefined) {
        this.data.method = method;
        this.dataChange.emit(this.data);
        if (method) {
            this.onMethodPick();
        }
    }
}
